var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "MarketingPosition" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "发圈素材", name: "ScrunchieMaterial" } },
            [
              _vm.activeName === "ScrunchieMaterial"
                ? _c("ScrunchieMaterial")
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "发圈分类", name: "ScrunchieClassification" } },
            [
              _vm.activeName === "ScrunchieClassification"
                ? _c("classification")
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "个性化", name: "individuation" } },
            [
              _vm.activeName === "individuation"
                ? _c("individuation")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }